import {Link} from 'react-router-dom';
import { APISERVERURL } from './APIServerURL';

const Post=({post,type})=>{

    let to=`/post/${post._id}`
    //alert(post._id);
    if(type!=='user')
    {
        to=`/searchpost/${post._id}`
    }
     
    const imgName=(post.images && post.images.length>0)?post.images[0]:"default.png";
    return( 
        <div className='imgThumbHome overLay'>
            <Link className='Link' to={to}>                        
                        <img  src={`${APISERVERURL}/img/${imgName}`} alt="placeholder" />
                        <div className='imgInfo'>
                            <div className="infoGroup">
                                <p className='headerText gridLabel'>Ondate:</p>
                                <p className='infoText gridInfo'>
                                    {post.datetime}
                                </p>
                            </div>
                            <div className="infoGroup">
                                <p className='headerText gridLabel'>From:</p>
                                <p className='infoText gridInfo'>
                                    { post.fromTime}
                                </p>
                            </div>
                            <div className="infoGroup">
                                <p className='headerText gridLabel'>To:</p>
                                <p className='infoText gridInfo'>
                                    { post.toTime}
                                </p>
                            </div>

                            <div className="infoGroup">
                                    <p className='headerText gridLabel'>Activity:</p>
                                    <p className='infoText gridInfo'>
                                        {post.activity.length > 25 ? post.activity.substring(0, 25) + '...' : post.activity}
                                    </p>
                                </div>
                                <div className="infoGroup">
                                    <p className='headerText gridLabel'>Outcome:</p>
                                    <p className='infoText gridInfo'>
                                        {post.outcome.length > 25 ? post.outcome.substring(0, 25) + '...' : post.outcome}
                                    </p>
                                </div>

                                <div className="infoGroup">
                                    <p className='headerText gridLabel'>Photos:</p>
                                    <p className='infoText gridInfo'>
                                        {post.images.length}
                                    </p>
                                </div>
                            
                        </div>
            </Link>
        </div>  
    )
}
export default Post